import { useState, useRef } from 'react';
import '../css/components/intake.css';
import '../css/components/custom.css';

import { AiFillGoogleSquare } from 'react-icons/ai';
import { Link, useHistory } from 'react-router-dom';
import CarafemLogo from '../images/carafem.png'

import { useAuth } from '../contexts/AuthContext';

import {
  AuthContainer,
  AuthForm,
  MainTagline,
  LogoContainer,
  Logo,
  Divider,
  Text,
  Line,
  SocialLoginContainer,
  SocialLoginText,
  ForgotPassword,
  AuthError,
} from '../styles/authForm';
import logo from '../images/logo.svg';

import InputField from './InputField';
import Button from './Button';

function SignIn() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const emailRef = useRef();
  const passwordRef = useRef();

  const history = useHistory();

  const { signin, signInWithGoogle } = useAuth();

  const handleSignin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const email = emailRef.current.value;
    const password = passwordRef.current.value;
    signin(email, password)
      .then((ref) => {
        setLoading(false);
        history.push('/');
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };

  const googleSignin = (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    signInWithGoogle()
      .then((ref) => {
        setLoading(false);
        history.push('/');
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  };


  return (
    <AuthContainer>
      <LogoContainer>
        <Logo src={CarafemLogo} />
        <MainTagline> Birth control? Yeah, we do that. </MainTagline>
        {/*<Logo src={logo} alt="logo" />*/}
      </LogoContainer>

      <AuthForm onSubmit={(e) => handleSignin(e)}>
        <InputField
          inputPlaceholder="Email"
          inputType="email"
          labelText="Email"
          inputRef={emailRef}
          inputRequired={true}
        />

        <InputField
          inputPlaceholder="Password"
          inputType="password"
          labelText="Password"
          inputRef={passwordRef}
          inputRequired={true}
        />

        <Button
          type="submit"
          disabled={loading}
          color="#0095F6"
          text="Log In"
        />

        {error && <AuthError>{error}</AuthError>}
      </AuthForm>

      <Divider>
        <Line />
        <Text>OR</Text>
        <Line />
      </Divider>

      <SocialLoginContainer>
        <AiFillGoogleSquare fontSize="1.3rem" color="#385185" />
        <SocialLoginText onClick={(e) => googleSignin(e)}>Log in with Google</SocialLoginText>
      </SocialLoginContainer>

      <ForgotPassword>
        <Link to="/accounts/password/reset">Forgot password?</Link>
      </ForgotPassword>
    </AuthContainer>
  );
}

export default SignIn;
